// "N Stempel werden gesendet" fuer den persoenlichen Offline-Puffer (TQ #556) -- gleiche
// Optik und gleiche Regel wie PendingBanner: nie wegklickbar, ab Schwelle dringlicher.

const URGENT_THRESHOLD = 5

interface Props {
  pendingCount: number
}

export function PersonalOutboxBanner({ pendingCount }: Props) {
  if (pendingCount === 0) return null

  const urgent = pendingCount >= URGENT_THRESHOLD

  return (
    <div className={`pending-banner${urgent ? ' urgent' : ''}`}>
      {pendingCount} {pendingCount === 1 ? 'Stempel wird' : 'Stempel werden'} gesendet
      {urgent ? ' — bitte Gerät ins Netz bringen' : ''}
    </div>
  )
}
